import { BODY_TYPE_FILTER_CATEGORY } from '../../../core/reducers/vehicleListFilters';
export const getProps = (sitecoreFields) => {
    const filterOptionsList = sitecoreFields.filterType.map(filter => {
        const title = filter.filterCategory.filterCategoryName || '';
        const key = filter.filterCategory.name || '';
        const { items } = filter.filterCategory;
        const options = items.map(item => {
            var _a;
            return ({
                label: item.filterName || '',
                icon: (_a = item.icon) === null || _a === void 0 ? void 0 : _a.item,
                key: `${key}|${item.name}` || '',
                selected: false,
                disabled: false,
                handleClick: () => { }, // set in useInventoryFilterOptionsList
            });
        });
        return {
            title,
            key,
            options,
        };
    });
    return {
        filterOptionsList,
        labels: {
            resetFilters: sitecoreFields.resetFilters || '',
            trimAvailablePlural: sitecoreFields.trimAvailablePlural || '',
            trimAvailableSingular: sitecoreFields.trimAvailableSingular || '',
        },
    };
};
export const getBodyTypeFiltersFromProps = (props) => {
    var _a;
    const bodyTypeProp = props.filterOptionsList.find(field => field.key === BODY_TYPE_FILTER_CATEGORY);
    if (!bodyTypeProp) {
        return [];
    }
    return (_a = bodyTypeProp.options) === null || _a === void 0 ? void 0 : _a.map(option => {
        const key = option.key.split('|')[1];
        if (!key) {
            return {};
        }
        return {
            [key]: option.label,
        };
    }, []);
};
export const getInventoryTrimFilterOptions = (allInventory) => {
    const options = Object.values(allInventory.reduce((acc, { trimKey, trimName }) => {
        if (!acc[trimName]) {
            acc[trimName] = { trimName, trimKeys: [trimKey] };
        }
        else {
            // @ts-ignore
            acc[trimName].trimKeys.push(trimKey);
        }
        return acc;
    }, {})).map(option => ({
        ...option,
        trimKeys: [...new Set(option.trimKeys)],
    }));
    return options;
};
